import { memo, useMemo } from 'react';
import { isThaiLocale } from '@sas/nova-core/i18n/localeUtils';
import { useFormatLocale } from '../../../locale/formatting/useFormatLocale';
import { convertGregorianYearToThaiYear, getMonthsForLocale } from '../../DatePicker/DateUtil';
import cn from '../Calendar.css.json';
import '../Calendar.css';
import { jsx as _jsx } from "react/jsx-runtime";
export const MultipleMonthCalendarHeader = /*#__PURE__*/memo(function MultipleMonthCalendarHeader(props) {
  const locale = useFormatLocale();
  const months = useMemo(() => getMonthsForLocale(locale), [locale]);
  return /*#__PURE__*/_jsx("div", {
    "data-testid": props.testId,
    className: cn.multipeMonthCalHeadText,
    children: `${months[props.month.getMonth()]} ${isThaiLocale(locale) && props.month.getFullYear() > 999 // Thai year should be at least 4 digits
    ? convertGregorianYearToThaiYear(props.month.getFullYear()) : props.month.getFullYear()}`
  });
});
//# sourceMappingURL=MultipleMonthCalendarHeader.js.map